import classNames from "classnames";
import React from "react";
import styles from "./index.module.scss";
export const Skeleton = (props) => {
    var _a;
    return (React.createElement("div", { className: classNames(styles.base, {
            [styles.circular]: props.type === "circular",
        }, props.className), style: Object.assign({ width: props.width, height: (_a = props.height) !== null && _a !== void 0 ? _a : (props.type === "circular" ? props.width : undefined), borderRadius: props.type === "text" ? props.height : undefined }, props.style), id: props.id }));
};
//# sourceMappingURL=index.js.map